import withSummarySaleDetail from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/withSummarySaleDetail'
import SummarySaleDetailView from '@features/myWriting/pages/MyWritingPage/components/SaleSummary/components/SummarySaleDetail/SummarySaleDetail'

const SummarySaleDetail = withSummarySaleDetail(SummarySaleDetailView)

export default SummarySaleDetail
